export interface PropertyAddressData {
  customer_id: string
  name: string
  address: string
  address_line_2: string
  city: string
  state: string
  zip: string
}

export interface PropertyInfoData {
  building_type: string
  units: string
  stories: string
  access_type: string
  access_info: string
}

export interface PropertyPaymentData {
  payment_method: string
  sales_tax_status: string
}

export interface AdditionalAccess {
  id: string
  location: string
  access_type: string
  access_info: string
}

export interface PropertyNote {
  timestamp: string
  note: string
}

export interface PropertyCustomerOption {
  id: string
  company_name: string
}

export const BUILDING_TYPES = ['Residential', 'Commercial', 'Office', 'Other']
export const ACCESS_TYPES = ['Keypad', 'Key', 'Keyfob', 'Lockbox', 'Numberlock', 'Other']
export const PAYMENT_METHODS = ['Check', 'CC', 'ACH', 'Other']
export const SALES_TAX_STATUSES = ['Taxable', 'Non-Taxable', 'Exempt']

/** Empty string means inherit from the parent customer */
export const CUSTOMER_DEFAULT_VALUE = ''
export const CUSTOMER_DEFAULT_LABEL = 'Customer Default'

export interface CustomerPaymentDefaults {
  payment_method?: string | null
  sales_tax_status?: string | null
}

export function isPropertyUsingCustomerDefault(value: string | null | undefined): boolean {
  return !value || !String(value).trim()
}

export function resolvePropertyPaymentMethod(
  propertyValue: string | null | undefined,
  customer?: CustomerPaymentDefaults | null
): string | null {
  if (!isPropertyUsingCustomerDefault(propertyValue)) return String(propertyValue).trim()
  const customerValue = customer?.payment_method
  return customerValue?.trim() || null
}

export function resolvePropertySalesTaxStatus(
  propertyValue: string | null | undefined,
  customer?: CustomerPaymentDefaults | null
): string | null {
  if (!isPropertyUsingCustomerDefault(propertyValue)) return String(propertyValue).trim()
  const customerValue = customer?.sales_tax_status
  return customerValue?.trim() || null
}

export function customerDefaultOptionLabel(
  field: 'payment_method' | 'sales_tax_status',
  customerDefaults?: CustomerPaymentDefaults | null
): string {
  const value = customerDefaults?.[field]
  if (value?.trim()) return `${CUSTOMER_DEFAULT_LABEL} (${value.trim()})`
  return CUSTOMER_DEFAULT_LABEL
}

export function formatPropertyPaymentMethod(
  propertyValue: string | null | undefined,
  customer?: CustomerPaymentDefaults | null
): string {
  if (propertyValue?.trim()) return propertyValue.trim()
  const resolved = resolvePropertyPaymentMethod(propertyValue, customer)
  if (resolved) return `${CUSTOMER_DEFAULT_LABEL} → ${resolved}`
  return `${CUSTOMER_DEFAULT_LABEL} (not set on customer)`
}

export function formatPropertySalesTaxStatus(
  propertyValue: string | null | undefined,
  customer?: CustomerPaymentDefaults | null
): string {
  if (propertyValue?.trim()) return propertyValue.trim()
  const resolved = resolvePropertySalesTaxStatus(propertyValue, customer)
  if (resolved) return `${CUSTOMER_DEFAULT_LABEL} → ${resolved}`
  return `${CUSTOMER_DEFAULT_LABEL} (not set on customer)`
}
